/**
 * Clase que contiene funciones genéricas relacionadas
 * con las estadísticas.
 *
 * @constructor
 */
function StatsUtil()
{

}

StatsUtil.BASE_TEMPLATE = 'base';
StatsUtil.LIST_VIDEOS = 'list_videos';
StatsUtil.VIDEO_DETAIL = 'video_detail';

// identificadores de categoría para establecer la orientación de un vídeo

StatsUtil.GAY_CATEGORIES = {
    'pornburst': [31],
    'serviporno': [31],
    'canalporno': [45]
};

StatsUtil.TRANS_CATEGORIES = {
    'pornburst': [35],
    'serviporno': [35],
    'canalporno': [46]
};

// constantes para identificar la orientación de un vídeo al entrar en su detalle

StatsUtil.VIDEO_PROFILE_HETERO = 'G0';
StatsUtil.VIDEO_PROFILE_GAY = 'G1';
StatsUtil.VIDEO_PROFILE_TRANS = 'G2';

StatsUtil.separator = ' | '; // separador utilizado en el listado de categorías y pornstars

/**
 * Imprime l@s pornstars de un vídeo a partir de un
 * objeto con toda la información sobre él, en el formato
 * adecuado para el envío de estadísticas.
 *
 * @param video
 * @returns {string}
 */
StatsUtil.printVideoPornstars = function(video)
{
    var pornstars = '';

    if(video.pornstars instanceof Array)
    {
        var numPornstars = video.pornstars.length;

        for(var i = 0 ; i < numPornstars ; i++)
        {
            var pornstar = video.pornstars[i];

            pornstars += pornstar.name;

            if(i < (numPornstars - 1))
            {
                pornstars += StatsUtil.separator;
            }
        }
    }

    return pornstars;
};

/**
 * Imprime las categorías de un vídeo a partir de un
 * objeto con toda la información sobre él, en el formato
 * adecuado para el envío de estadísticas.
 *
 * @param video
 * @param lang
 * @param suffix
 *
 *      Sufijo especial para los tubes que tienen un valor
 *      numérico en la columna del idioma, como es el caso
 *      de PornBurst.
 *
 * @returns {string}
 */
StatsUtil.printVideoCategories = function(video, lang, suffix)
{
    var categories = '';

    if(typeof lang != 'string')
    {
        return categories;
    }

    if(video.categories instanceof Array)
    {
        var numCategories = video.categories.length;

        for(var i = 0 ; i < numCategories ; i++)
        {
            var category = video.categories[i];

            categories += category['name' + lang.charAt(0).toUpperCase() + lang.slice(1) + suffix];

            if(i < (numCategories - 1))
            {
                categories += StatsUtil.separator;
            }
        }
    }

    return categories;
};

/**
 * Obtiene el nombre de la lista a la que pertenece un vídeo
 * dentro de las galerías de la página de inicio en función
 * del tamaño de la galería principal.
 *
 * @param pos
 * @param mostPopularListLength
 * @returns {*}
 */
StatsUtil.getVideoListName = function(pos, mostPopularListLength)
{
    if(mostPopularListLength == 0)
    {
        return 'Index';
    }
    else
    {
        if(pos <= mostPopularListLength)
        {
            return 'Index - Populares';
        }
        else
        {
            return 'Index - Nuevos';
        }
    }
};

/**
 * Obtiene la posición dentro de la lista a la que pertenece
 * un vídeo en las galerías de la página de inicio en función
 * del tamaño de la galería principal.
 *
 * @param pos
 * @param mostPopularListLength
 * @returns {*}
 */
StatsUtil.getVideoPositionInList = function(pos, mostPopularListLength)
{
    var posInList = pos;

    if(pos > mostPopularListLength)
    {
        posInList = pos - mostPopularListLength;
    }

    return posInList;
};

/**
 * Obtiene el tipo de dispositivo desde el que se está visualizando
 * la página, que puede ser desktop, mobile o tablet.
 *
 * @returns {*}
 */
StatsUtil.getDevice = function()
{
    if(StatsUtil.isTablet())
    {
        return 'tablet';
    }
    else
    {
        return 'mobile';
    }
};

StatsUtil.isTablet = function()
{
    return (navigator.userAgent.toLowerCase().indexOf('ipad')!='-1')
        || (navigator.userAgent.toLowerCase().indexOf('android')!='-1' && navigator.userAgent.toLowerCase().indexOf('mobile') == '-1')
        || (navigator.userAgent.toLowerCase().indexOf('playbook')!='-1')
        || (navigator.userAgent.toLowerCase().indexOf('silk')!='-1');
};